import { render } from "./QyList.vue?vue&type=template&id=512b0331"
import script from "./QyList.vue?vue&type=script&lang=js"
export * from "./QyList.vue?vue&type=script&lang=js"

import "./QyList.vue?vue&type=style&index=0&id=512b0331&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__